// src/app/.../CloudServicesPage.jsx
import React from 'react';
import { Grid } from '@mui/material';
import ServiceStatusCard from '../../../../components/cloudServices/ServiceStatusCard';
import PublicPanelCard from '../../../../components/cloudServices/PublicPanelCard';
import LegendaLatencia from '../../../../components/cloudServices/LegendaLatencia';

export default function CloudServicesPage() {
  const services = [
    { name: 'Sirrus Cook API', url: 'https://cloud.sirruscook.app/api/server-status'},
    { name: 'Sirrus Ponto API', url: 'https://sirruspontoapi.sirrus.com.br/api/server-status' },
    { name: 'Sirrus Completo Web', url: 'https://app.sirruscompleto.com.br/health' },
    { name: 'Sirrus Comércio API', url: 'https://cloud.sirruscomercio.app/api/server-status' },
    { name: 'Sirrus Moda API', url: 'https://cloud.sirrusmoda.app/api/server-status' },
  ];

  // painéis oficiais (sem API)
  const panels = [
    {
      name: 'Painel Oficial NF-e (Portal Nacional)',
      href: 'https://www.nfe.fazenda.gov.br/portal/disponibilidade.aspx',
      description: 'Consulte a disponibilidade dos serviços de NF-e por UF no Portal Nacional (RO é atendida pela SVRS).'
    },
    {
      name: 'Painel Oficial NFC-e (Portal SVRS)',
      href: 'https://dfe-portal.svrs.rs.gov.br/Nfce/Disponibilidade',
      description: 'Consulte a disponibilidade dos Web Services de NFC-e (inclui UFs atendidas pela SVRS, como RO).'
    }
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <LegendaLatencia />
      </Grid>

      {panels.map((p, i) => (
        <Grid item xs={12} md={6} key={`panel-${i}`}>
          <PublicPanelCard name={p.name} description={p.description} href={p.href} />
        </Grid>
      ))}

      {/* Seus serviços internos com medição de latência */}
      {services.map((service, index) => (
        <Grid item xs={12} md={6} key={`svc-${index}`}>
          <ServiceStatusCard name={service.name} url={service.url} />
        </Grid>
      ))}

    </Grid>
  );
}
